<template>
  <section class="info-section">
    <h3 class="section-title">
      基本情報
    </h3>
    <div class="base-info-grid">
      <div>
        <div class="label">
          ユーザーID
        </div>
        <div class="value">
          {{ displayValue(userId) }}
        </div>
      </div>
      <div v-if="showUserName">
        <div class="label">
          セイメイ
        </div>
        <div class="value">
          {{ displayValue(userName) }}
        </div>
      </div>
      <div>
        <div class="label">
          性別
        </div>
        <div class="value">
          {{ displayValue(userGender) }}
        </div>
      </div>
      <div>
        <div class="label">
          最終出産日/出産予定日
        </div>
        <div class="value">
          {{ displayValue(lastDueDate) }}
        </div>
      </div>
      <div class="coupon-col">
        <div class="label">
          適用中のクーポン
        </div>
        <div class="coupon-value-row">
          <span class="value">{{ displayValue(coupon) }}</span>
          <span
            v-if="couponId !== null && couponId !== undefined && couponId !== '' && coupon !== '' && coupon !== '-'"
            class="coupon-id"
          >
            (ID: {{ couponId }})
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  userId: {
    type: [String, Number],
    default: null,
  },
  userName: {
    type: String,
    default: "",
  },
  showUserName: {
    type: Boolean,
    default: true,
  },
  userGender: {
    type: String,
    default: "",
  },
  lastDueDate: {
    type: String,
    default: "",
  },
  coupon: {
    type: String,
    default: "",
  },
  couponId: {
    type: [String, Number],
    default: "",
  },
});

const displayValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};
</script>

<style lang="scss" scoped>
.info-section {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
}

.section-title {
  color: #33B5B4;
  font-size: clamp(16px, 1vw, 20px);
  line-height: 1.25;
  font-weight: 700;
  margin-bottom: 6px;
}

.base-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
}

.coupon-col {
  grid-column: 1 / -1;
}

.coupon-value-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}

.label {
  color: #7a7a7a;
  font-size: 12px;
}

.value {
  color: #222;
  font-weight: 600;
  font-size: clamp(14px, 0.95vw, 18px);
  line-height: 1.35;
}

.coupon-id {
  color: #666;
  font-weight: 500;
  font-size: clamp(12px, 0.8vw, 15px);
  line-height: 1.35;
}

@media (max-width: 1280px) {
  .section-title {
    font-size: 15px;
  }

  .label {
    font-size: 11px;
  }

  .value {
    font-size: 14px;
  }

  .coupon-id {
    font-size: 12px;
  }
}
</style>
